import React from "react";
import { Link } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "../context/AuthProvider";
import ImageTextOverlay from "../components/Home/ImageTextOverlay";
import WhyChooseUs from "../components/Home/WhyChooseUs";
import About from "../components/Home/LandingPageAboutUs";
import WhatWeDo from "../components/Home/WhatWeDo";
import TestimonialSection from "../components/Home/Testimonial";
import CallToAction from "../components/Home/SubmitMusic";
import StreamingSocialStats from "../components/Home/SocialStats";
import imageText from "../assets/images/image3.jpg";
import aboutUs from "../assets/images/image11.jpg";

const HomePage = () => {
   const { user, loading } = useContext(AuthContext);  
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 to-gray-800 text-white">
      <ImageTextOverlay image={imageText} user={!!user}/>
      <WhyChooseUs />
      <About image={aboutUs}/>
      <WhatWeDo />
      <TestimonialSection />
      <CallToAction user={!!user} />
      <StreamingSocialStats />
    </div>
  );
};

export default HomePage;
